import type {
  RevenueThisMonthInsightsDTO,
  RevenueThisMonthInsightItemDTO,
} from "../models/revenueThisMonthInsightsDto";
import type {
  RevenueThisMonthInsightsEntity,
  RevenueThisMonthInsightItemEntity,
} from "../../domain/entities/RevenueThisMonthInsightsEntity";

function normalizeItem(
  item: RevenueThisMonthInsightItemDTO,
): RevenueThisMonthInsightItemEntity {
  return {
    title: item.title,
    description: item.description,
    accentColor: item.accentColor === "success" ? "success" : "neutral",
  };
}

export function revenueThisMonthInsightsDtoToEntity(
  dto: RevenueThisMonthInsightsDTO,
): RevenueThisMonthInsightsEntity {
  return {
    monthLabel: dto.monthLabel,
    insights: Array.isArray(dto.insights)
      ? dto.insights.map(normalizeItem)
      : [],
  };
}
